"use client";

/**
 * The brand's bar nights, and which of them are on right now by this
 * device's clock (re-checked every minute). One subscribed query — Convex
 * shares it between the till, the Kitchen board and the banner.
 */

import { useEffect, useMemo, useState } from "react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import type { Id } from "@/convex/_generated/dataModel";
import { momentNow, nightIsOn, type NightMoment } from "@/lib/config/nights";

export function useNightsOn(brandId: Id<"brands"> | string | undefined | null, storeId?: Id<"stores"> | string | null) {
  const nights = useQuery(
    api.foodBeverage.nights.getActiveNights,
    brandId ? { brandId: brandId as Id<"brands">, storeId: (storeId as Id<"stores"> | undefined) || undefined } : "skip",
  );
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((x) => x + 1), 60_000);
    return () => clearInterval(t);
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const at: NightMoment = useMemo(() => momentNow(), [tick, nights]);
  const on = useMemo(() => (nights || []).filter((n) => nightIsOn(n, at)), [nights, at]);
  return { nights: nights || [], on, at, loading: nights === undefined };
}
